import { http } from "../../utils/config";

/**
 * API nhật ký HÀNH ĐỘNG người dùng + AUDIT thay đổi model (bảng logs).
 * Dùng chung axios instance `http` (tự gắn Bearer token) — không axios thô.
 */
const logActionAPI = {
  // Danh mục nhãn action (phục vụ dropdown filter)
  getActions: () => http.get("/api/v1/serviceconnect/logs/actions"),

  // Danh sách nhật ký (action + audit) có filter + phân trang
  getLogs: (params = {}) => {
    const {
      page = 1,
      action = "",
      search = "",
      is_read = "",
      from_date = "",
      to_date = "",
    } = params;

    const queryParams = new URLSearchParams({ page: page.toString() });
    if (action) queryParams.set("action", action);
    if (search) queryParams.set("search", search);
    if (is_read !== "" && is_read !== undefined && is_read !== null) {
      queryParams.set("is_read", is_read);
    }
    if (from_date) queryParams.set("from_date", from_date);
    if (to_date) queryParams.set("to_date", to_date);

    return http.get(`/api/v1/serviceconnect/logs/view-daily-log-actions?${queryParams}`);
  },

  // Đánh dấu đã đọc (mảng id)
  markAsRead: (ids = []) => http.post("/api/v1/serviceconnect/logs/mark-as-read", { ids }),
};

export default logActionAPI;
